import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { useLocation } from 'react-router-dom';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const isPlayPage = location.pathname === '/play';
  const isWalkStoryPage = location.pathname === '/walk-the-story';
  
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        {children}
      </main>
      {!isPlayPage && !isWalkStoryPage && <Footer />}
    </div>
  );
};

export default Layout; 